module.exports = __webpack_public_path__ + "img/2.ddfb19d3.png";